<template>
  <div>
    <BAutocomplete
      ref="autocomplete"
      v-model="unit_name"
      clearable
      :data="Object.values(units)"
      data-test="select-unit-input"
      :disabled="isDisabled"
      field="attributes.name_with_customer"
      icon="magnifying-glass"
      keep-first
      :open-on-focus="true"
      :placeholder="isDisabled ? $t('decision_type.validation.projectRequired') : null"
      @focus.stop="$emit('focus')"
      @input="searchUnit"
      @select="selectUnit">
      <template slot="empty">
        <div data-test="empty-result">
          <div v-if="is_searching">
            {{ $t('select.actions.noResults') }} <span v-if="unit_name">"{{ unit_name }}"</span>
          </div>
          <div v-else>
            {{ $t('select.actions.startTyping') }}
          </div>
        </div>
      </template>
    </BAutocomplete>
  </div>
</template>

<script>
export default {
  name: 'SelectUnit',
  props: {
    active: { type: Object, default: null },
    project_id: { type: String, default: null },
    project_required: { type: Boolean },
    units: { type: Object, default: null },
  },

  data() {
    return {
      unit_name: this.active ? this.active.attributes.name_with_customer : '',
      is_searching: false,
    };
  },

  computed: {
    isDisabled() {
      return this.project_required && _.isNil(this.project_id);
    },
  },

  watch: {
    active(newVal) {
      this.unit_name = _.get(newVal, 'attributes.name_with_customer', '');
    },
  },
  methods: {
    searchUnit(query) {
      this.is_searching = true;
      if (!this.active) {
        this.$emit('onSearch', query);
      }
    },

    selectUnit(unit) {
      this.$emit('changeSelect', unit);
    },
  },
};
</script>
